export default __webpack_public_path__ + "static/outsource@mob-05132e5ae05ea6379a4995683f4db5d4.webp";